import { render, staticRenderFns } from "./InvoicesDataTable.vue?vue&type=template&id=3b3a1333"
import script from "./InvoicesDataTable.vue?vue&type=script&lang=js"
export * from "./InvoicesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports